import { SellerListUrlSortField } from "@saleor/seller/urls";
import { UserSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(sort: SellerListUrlSortField): UserSortField {
  switch (sort) {
    case SellerListUrlSortField.name:
      return UserSortField.LAST_NAME;
    case SellerListUrlSortField.email:
      return UserSortField.EMAIL;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
